import locale from '../locale/default';
export default locale;
//# sourceMappingURL=default.js.map
